import { module } from 'modujs';
import { html } from '../utils/environment'
import { Swiper, Pagination, Navigation, Autoplay } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                'close': 'close'
            }
        };
    }

    init() {
        // If alerts banner was never dismissed or dismissed more than an hour ago, open the banner
        if (
            !window.localStorage.getItem('airinuit.alerts-banner-closed') ||
            ((Date.now() - window.localStorage.getItem('airinuit.alerts-banner-closed')) > (1000 * 60 * 60))
        ) {
            html.classList.add('has-alerts-banner-opened');
        }

        this.tip = this.$('tip')[0];
        this.alertsLink = document.getElementById('alerts-link');

        this.updateTip();
        this.checkResizeBind = this.checkResize.bind(this);
        window.addEventListener('resize', this.checkResizeBind);

        if (this.$('slide').length > 1) {
            this.carousel = new Swiper(this.$('carousel')[0], {
                modules: [
                    Pagination,
                    Navigation,
                    Autoplay,
                ],
                // loop: true,
                direction: 'vertical',
                slidesPerView: 1,
                loop: true,
                autoplay: {
                    delay: 5000
                },
                pagination: {
                    el: this.$('pagination')[0],
                    type: 'custom',
                    renderCustom: function (swiper, current, total) {
                        return current + ' / ' + total;
                    }
                },
                navigation: {
                    prevEl: this.$('arrow-prev')[0],
                    nextEl: this.$('arrow-next')[0]
                }
            });
        } else {
            this.$('navigation')[0].remove();
        }
    }

    checkResize() {
        if (!this.resizeTick) {
            this.resizeTick = true;

            requestAnimationFrame(() => {
                this.updateTip();
                this.resizeTick = false;
            });
        }
    }

    updateTip() {
        const linkBCR = this.alertsLink.getBoundingClientRect();
        this.tip.style.left = `${linkBCR.left + linkBCR.width / 2}px`;
    }

    close() {
        window.localStorage.setItem('airinuit.alerts-banner-closed', Date.now());
        html.classList.remove('has-alerts-banner-opened');

        if (this.carousel && this.carousel.autoplay && this.carousel.autoplay.stop) {
            this.carousel.autoplay.stop();
        }

        this.call('update', null, 'Scroll');
    }

    destroy() {
        super.destroy();

        window.removeEventListener('resize', this.checkResizeBind);

        if (this.carousel && this.carousel.destroy) {
            this.carousel.destroy();
        }
    }
}
